// @flow
import {
  ACTION_ADD_ITEMS,
  ACTION_ITEMS_FILTERED_FROM_ADD,
  ACTION_SUBMIT_IN_PROGRESS,
  ACTION_ON_ITEM_REMOVE,
  ACTION_TOGGLE_UPLOAD_MANAGER,
  ACTION_UPLOAD_IN_PROGRESS,
  ACTION_UPLOAD_PROGRESS_UPDATE,
  ACTION_TOO_MANY_FILES,
  ACTION_VALIDATION_FAILED,
  ACTION_CLOSE_NOTIFICATION,
  ACTION_SELECT_FIELD_ON_CHANGE,
  ACTION_LIST_FIELD_ON_CHANGE,
  ACTION_TEXT_FIELD_ON_CHANGE,
  ACTION_DATE_FIELD_ON_CHANGE,
  ACTION_SUBMISSION_FAILED,
  ACTION_FILE_SIZE_LIMIT_EXCEEDED,
  ACTION_INVALID_FILE_NAME,
  ACTION_PROCESSING_IN_PROGRESS,
  ACTION_UPDATE_COMPONENTS,
} from './form-submitter-constant';
import { ERRORS } from '../FormErrors';
import type { State, Action } from './form-submitter-type';
import removeUndefined from '../../../common/utils/removeUndefined';

export default (state: State, action: Action): State => {
  let newState = state;
  switch (action.type) {
    case ACTION_ADD_ITEMS:
      {
        const { id, itemQueue, errorId } = action;
        newState = {
          ...state,
          hasChange: true,
          itemQueues: {
            ...state.itemQueues,
            [id]: itemQueue,
          },
          errors: removeUndefined({
            ...state.errors,
            [id]: errorId,
          }),
        };
      }
      break;
    case ACTION_ON_ITEM_REMOVE:
      {
        const { id, itemQueue, errorId } = action;
        newState = {
          ...state,
          itemQueues: {
            ...state.itemQueues,
            [id]: itemQueue,
          },
          errors: removeUndefined({
            ...state.errors,
            [id]: errorId,
          }),
        };
      }
      break;
    case ACTION_SELECT_FIELD_ON_CHANGE:
      {
        const { id, newValues, errorId } = action;
        newState = {
          ...state,
          hasChange: true,
          response: {
            ...state.response,
            [id]: newValues,
          },
          errors: removeUndefined({
            ...state.errors,
            [id]: errorId,
          }),
        };
      }
      break;
    case ACTION_LIST_FIELD_ON_CHANGE:
      {
        const { id, newValues, errorId } = action;
        newState = {
          ...state,
          hasChange: true,
          response: {
            ...state.response,
            [id]: newValues,
          },
          error: removeUndefined({
            ...state.errors,
            [id]: errorId,
          }),
        };
      }
      break;
    case ACTION_TEXT_FIELD_ON_CHANGE:
    case ACTION_DATE_FIELD_ON_CHANGE:
      {
        const { id, newValue, errorId } = action;
        newState = {
          ...state,
          hasChange: true,
          response: {
            ...state.response,
            [id]: newValue,
          },
          errors: removeUndefined({
            ...state.errors,
            [id]: errorId,
          }),
        };
      }
      break;
    case ACTION_TOGGLE_UPLOAD_MANAGER:
      newState = {
        ...state,
        isUploadManagerExpanded: !state.isUploadManagerExpanded,
      };
      break;
    case ACTION_VALIDATION_FAILED:
      {
        const { errors: errorsWithNotification = {} } = action;
        const { notificationOverride, ...errors } = errorsWithNotification;
        newState = {
          ...state,
          errors,
          isInvalid: true,
          errorNotificationMessage:
            notificationOverride || ERRORS.FORM_INCOMPLETE,
          validateOnChange: true,
        };
      }
      break;
    case ACTION_ITEMS_FILTERED_FROM_ADD:
      newState = {
        ...state,
        errorNotificationMessage: ERRORS.ITEMS_FILTERED_FROM_ADD,
      };
      break;
    case ACTION_TOO_MANY_FILES:
      newState = {
        ...state,
        isInvalid: true,
        errorNotificationMessage: ERRORS.TOO_MANY_FILES,
      };
      break;
    case ACTION_FILE_SIZE_LIMIT_EXCEEDED:
      newState = {
        ...state,
        isInvalid: true,
        errorNotificationMessage: ERRORS.FILE_SIZE_LIMIT_EXCEEDED,
      };
      break;
    case ACTION_INVALID_FILE_NAME:
      newState = {
        ...state,
        isInvalid: true,
        errorNotificationMessage: ERRORS.INVALID_FILE_NAME,
      };
      break;
    case ACTION_CLOSE_NOTIFICATION:
      newState = {
        ...state,
        errorNotificationMessage: null,
      };
      break;
    case ACTION_SUBMIT_IN_PROGRESS:
      newState = {
        ...state,
        submitInProgress: true,
        isInvalid: false,
      };
      break;
    case ACTION_UPLOAD_IN_PROGRESS:
      {
        const { uploader } = action;
        newState = {
          ...state,
          uploader,
          isUploadsManagerVisible: true,
          isUploadManagerExpanded: true,
        };
      }
      break;
    case ACTION_UPLOAD_PROGRESS_UPDATE:
      newState = {
        ...state,
        uploader: state.uploader,
      };
      break;
    case ACTION_PROCESSING_IN_PROGRESS:
      newState = {
        ...state,
        processingInProgress: true,
      };
      break;
    case ACTION_SUBMISSION_FAILED: {
      newState = {
        ...state,
        isInvalid: true,
        errorNotificationMessage: ERRORS.SUBMISSION_FAILED,
        submitInProgress: false,
        submissionFailed: true,
        processingInProgress: false,
      };
      break;
    }
    case ACTION_UPDATE_COMPONENTS: {
      const updatedComponents = action.payload;

      newState = {
        ...state,
        components: updatedComponents,
      };
      break;
    }
    default:
  }
  return newState;
};
